export class RRFooterModel {
  initialYear: number;
  currentYear: number;
  version: string;
  siteName: string;
  url: string;
}
